import React from "react";
import HeaderComponent from "@components/common/Header/Header";
import DocumentIcon from "@styles/all-images/images/main-content-image.png";
import BackIcon from "@styles/all-images/icons/back-button.svg";

const ApprovedOnBoardingDocumentShow: React.FC = () => {
  return (
    <div className="tw-relative">
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-pt-4 tw-pb-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/approved-on-boarding-document">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Financial Statement Year 1 (Unaudited)
              </h1>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-flex tw-items-start tw-gap-6">
          <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-[20%]">
            <div className="tw-flex tw-justify-between tw-items-center tw-px-6 tw-py-4">
              <h2 className="tw-text-base tw-font-semibold tw-text-[#232323]">
                SOP
              </h2>
            </div>
            <hr />
            <div className="tw-px-6 tw-py-4 tw-ml-5">
              <ul>
                <li className="tw-text-[#232323] tw-text-sm tw-font-medium tw-list-disc tw-mb-2">
                  Directors Checked on CIPC?
                </li>
                <li className="tw-text-[#232323] tw-text-sm tw-font-medium tw-list-disc tw-mb-2">
                  Financial Year End Accurately Entered?
                </li>
              </ul>
            </div>
          </div>
          <div className="tw-w-[60%] tw-flex tw-flex-col tw-gap-6">
            <img src={DocumentIcon} alt="File Icon" />
          </div>
          <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-[20%]">
            <div className="tw-flex tw-justify-between tw-items-center tw-px-6 tw-py-4">
              <h2 className="tw-text-base tw-font-semibold tw-text-[#232323]">
                Inputs
              </h2>
            </div>
            <hr />
            <div className="tw-px-6 tw-py-4">
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Auditor Company Name
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  Mnguni & Partners Chartered Accountants
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Auditor Email
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  audits@mngunipartners.co.za
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Auditor Phone Number
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  +27 11 555 1234
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Auditor Opinion
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  The financial statements present a true and fair view of the
                  company's financial position.
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Directors Names
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  Sipho Mthembu
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Shareholding Breakdown
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  40%
                </h2>
              </div>
              <div className="tw-mb-3">
                <span className="tw-text-[#414651] tw-text-sm tw-font-medium">
                  Financial Year End
                </span>
                <h2 className="tw-text-[#232323] tw-text-base tw-font-medium">
                  31 March 2024
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovedOnBoardingDocumentShow;
